import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const { pathname } = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/courses", label: "Courses" },
    { path: "/dashboard", label: "Dashboard" },
    { path: "/apply", label: "Apply" },
    { path: "/internship-policy", label: "Internship Policy" },
  ];

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [pathname]);

  return (
    <nav
      className={`fixed top-0 w-full z-50 bg-white bg-opacity-90 backdrop-blur-md transition-shadow duration-300 ${
        scrolled ? "shadow-lg" : "shadow-md"
      } font-sans px-6 md:px-8 py-4 flex justify-between items-center`}
      role="navigation"
      aria-label="Primary Navigation"
    >
      <Link to="/" className="flex items-center">
        <img src="/Logo.png" alt="Techverra Logo" className="h-16 w-auto mr-3" />
        <span className="text-xl font-semibold tracking-wide whitespace-nowrap">
          Techverra Internships
        </span>
      </Link>

      {/* Desktop Menu */}
      <div className="hidden md:flex space-x-10 items-center">
        {navItems.map(({ path, label }) => (
          <Link
            key={path}
            to={path}
            aria-current={pathname === path ? "page" : undefined}
            className={`relative font-medium transition-colors duration-300 ${
              pathname === path
                ? "text-indigo-600"
                : "text-gray-700 hover:text-indigo-500"
            }`}
          >
            {label}
            {/* Underline */}
            <span
              className={`absolute left-0 bottom-[-4px] h-0.5 w-full bg-indigo-600 rounded transition-all duration-300 ${
                pathname === path ? "opacity-100" : "opacity-0"
              }`}
            />
          </Link>
        ))}
      </div>

      {/* Mobile Menu Button */}
      <button
        onClick={() => setMobileMenuOpen((prev) => !prev)}
        aria-expanded={mobileMenuOpen}
        aria-label="Toggle menu"
        className="md:hidden p-2 rounded-md text-gray-700 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      >
        {/* Hamburger Icon */}
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          {mobileMenuOpen ? (
            <path d="M6 18L18 6M6 6l12 12" /> // X icon
          ) : (
            <path d="M3 12h18M3 6h18M3 18h18" /> // Hamburger icon
          )}
        </svg>
      </button>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white bg-opacity-95 backdrop-blur-md shadow-lg flex flex-col items-center py-4 md:hidden">
          {navItems.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              aria-current={pathname === path ? "page" : undefined}
              className={`block w-full text-center py-3 font-medium transition-colors duration-300 ${
                pathname === path
                  ? "text-indigo-600"
                  : "text-gray-700 hover:text-indigo-500"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
